"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const native_bridge_1 = require("./utils/native-bridge");
const config_1 = require("./config");
/**
 * Class chứa các action liên quan đến Ads
 */
class Ads {
    /**
     * Open Interstitial Ads
     * @example
     * ZJSBridge.Ads.openInterstitialAds({}, e => {console.log(e)})
     * @param {object} data
     * @param {void} callback Hàm callback trả về kết quả sau khi gọi action
     */
    static openInterstitialAds(data, callback) {
        return native_bridge_1.default.jsCall(config_1.Action.openInterstitialAds, data, callback, true);
    }
    /**
     * Open Reward Ads
     * @example
     * ZJSBridge.Ads.openRewardAds({}, e => {console.log(e)})
     * @param {object} data
     * @param {void} callback Hàm callback trả về kết quả sau khi gọi action
     */
    static openRewardAds(data, callback) {
        return native_bridge_1.default.jsCall(config_1.Action.openRewardAds, data, callback, true);
    }
    /**
     * Open Adtima Ads
     * @example
     * ZJSBridge.Ads.openAdtimaAds({}, e => {console.log(e)})
     * @param {object} data
     * @param {void} callback Hàm callback trả về kết quả sau khi gọi action
     */
    static openAdtimaAds(data, callback) {
        return native_bridge_1.default.jsCall(config_1.Action.openAdtimaAds, data, callback, true);
    }
    /**
     * Get Ads id
     * @example
     * ZJSBridge.Ads.getAdsID({}, e => {console.log(e)})
     * @param {object} data
     * @param {void} callback Hàm callback trả về kết quả sau khi gọi action
     */
    static getAdsID(data, callback) {
        return native_bridge_1.default.jsCall(config_1.Action.getAdsID, data, callback, true);
    }
}
exports.default = Ads;
